import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApiNoConversion } from '~/services/kyClient';

/**
 * Fetches the simplified JSON export for a single delivery note.
 *
 * The response is returned as a raw Blob so the original JSON payload can be
 * downloaded without any client-side key conversion.
 *
 * @param deliveryNoteId - The delivery note ID to export.
 * @param options - Optional request options such as an abort signal.
 * @returns The simplified delivery note export as a Blob.
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/get_delivery_note_by_id_asset_delivery_notes__dln_id__get
 */
export const fetchDeliveryNoteSimpleFormat = async (
  deliveryNoteId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApiNoConversion
    .get(ENDPOINT.DELIVERY_NOTE.GET_SIMPLE_FORMAT(deliveryNoteId), {
      ...options,
    })
    .blob();
